import '../../i18n/autoTranslate';
import React from 'react';
import Icon from '../../../components/AppIcon';
import SpotlightCard from '../../../components/ui/SpotlightCard';

const MetricCard = ({ 
  title, 
  value, 
  subtitle, 
  icon, 
  trend = null, 
  color = "primary",
  onClick = null 
}) => {
  const getColorClasses = () => {
    switch (color) {
      case 'accent':
        return {
          text: 'text-accent',
          border: 'border-accent/20',
          bg: 'bg-accent/5',
          spotlight: 'rgba(255, 0, 150, 0.2)'
        };
      case 'success':
        return {
          text: 'text-success',
          border: 'border-success/20',
          bg: 'bg-success/5',
          spotlight: 'rgba(0, 200, 100, 0.2)'
        };
      case 'warning':
        return {
          text: 'text-warning',
          border: 'border-warning/20',
          bg: 'bg-warning/5',
          spotlight: 'rgba(255, 150, 0, 0.2)'
        };
      case 'error':
        return {
          text: 'text-error',
          border: 'border-error/20',
          bg: 'bg-error/5',
          spotlight: 'rgba(255, 0, 0, 0.2)'
        };
      default:
        return {
          text: 'text-primary',
          border: 'border-primary/20',
          bg: 'bg-primary/5',
          spotlight: 'rgba(0, 150, 255, 0.2)'
        };
    }
  };

  const getTrendIcon = () => {
    if (!trend) return null;
    if (trend > 0) return { icon: 'TrendingUp', color: 'text-success' };
    if (trend < 0) return { icon: 'TrendingDown', color: 'text-error' };
    return { icon: 'Minus', color: 'text-muted-foreground' };
  };

  const trendInfo = getTrendIcon();
  const colorClasses = getColorClasses();

  return (
    <SpotlightCard
      className="relative rounded-2xl overflow-hidden border border-white/10 bg-white/5 backdrop-blur-xl shadow-[0_14px_50px_rgba(0,0,0,0.35)] p-5 custom-spotlight-card"
      // FIX: spotlightColor must be per-card (not hardcoded purple)
      spotlightColor={colorClasses.spotlight}
    >
      
      <div 
        className={`
          relative overflow-hidden z-10
          transition-all duration-200 ease-smooth  hover:-translate-y-1
          ${onClick ? 'cursor-pointer ' : ''}
        `}
        onClick={onClick}
      >
        {/* Background Glow */}
        <div className={`absolute top-0 right-0 w-16 h-16 ${colorClasses.bg} rounded-full blur-2xl opacity-25`} />
        
        <div className="relative z-10">
          {/* Header */}
          <div className="flex items-center justify-between mb-4">
            <div className={`flex items-center justify-center w-12 h-12 rounded-xl ${colorClasses.bg} ${colorClasses.border} backdrop-blur-md`}>
              <Icon name={icon} size={24} className={colorClasses.text} />
            </div>
            
            {trendInfo && (
              <div className={`flex items-center space-x-1 px-2 py-1 rounded-lg bg-black/20 backdrop-blur-sm ${trendInfo.color}`}>
                <Icon name={trendInfo.icon} size={14} />
                <span className="text-xs font-semibold">{Math.abs(trend)}%</span>
              </div>
            )}
          </div>

          {/* Content */}
          <div className="space-y-1">
            <h3 className={`font-bold text-foreground tracking-tight ${String(value).length > 5 ? 'text-xl md:text-2xl' : 'text-3xl md:text-4xl'}`}>
              {value}
            </h3>
            <p className="text-sm font-medium text-muted-foreground">{title}</p>
            {subtitle && (
              <p className="text-xs text-muted-foreground/60 mt-1">{subtitle}</p>
            )}
          </div>
        </div>
      </div>
    </SpotlightCard>
  );
};

export default MetricCard;
